module.exports = {
	"usdm": {
		"anchor": "US Drought Monitor",
		"href": "https://droughtmonitor.unl.edu/",
		"image": "samples/usdm_sample.jpg",
		"text": "The U.S. Drought Monitor is a weekly map of drought conditions produced jointly by the National Oceanic and Atmospheric Administration, the U.S. Department of Agriculture, and the National Drought Mitigation Center at the University of Nebraska-Lincoln.  The weekly maps are released at 8:30 a.m. Eastern Standard Time each Thursday and are assessments of past conditions based on data through 7 a.m. Eastern time (8 a.m. Eastern Daylight Time) the preceding Tuesday. The US Drought Monitor web site hosts an assortment of drought-related data and resources."
	},
	"ahps": {
		"anchor": "NWS NWPS precipitation maps",
		"href": "https://water.noaa.gov/#@=-75.1535991,42.2157613,5.0252764&b=topographic&g=obsFcst,0!0!0!0!0!0!0!0!0!0!0!0!0!0!0!0!0!0!0!0,0.5,0!0!0!0!0,0,0&ab=0,0,%23D94B4A,1,1,1,%23cccccc,1,0,0,%23B243B1,1,0,0,%2398E09A,1&a=hydrologic,0.35&s=0,0,0.9,0.9&n=false,%2372afe9,0.9,0,0.9,0,0.9&p=true,0.75,0,7,0,1,2024,4,18,0&d=0,0,1,1,1,1,1,1,%23006EFF,1,%23006EFF,1,%23006EFF&q=",
		"image": "samples/ahps_sample.jpg",
		"text": "National Weather Service Advanced Hydrologic Prediction Service precipitation maps are available for various time periods. Maps are based on a gridded field with a spatial resolution of roughly 4x4 km. Precipitation values are derived using a multisensor approach incorporating radar precipitation estimates, which are bias corrected with ground rainfall gauge reports. In areas with poor radar coverage, satellite precipitation estimates are also used. Maps are updated throughout the day and are usually complete for the entire country by 12:30 ET."
	},
	"nc-ahps": {
		"anchor": "SRCC Integrated Water Portal",
		"href": "https://srcc.tamu.edu/water_portal/",
		"image": "samples/nciwp_sample.png",
		"text": "AHPS-based maps of SPI, SPI Blend, and precipitation (total, departure, percent of normal) provided by the Southern Regional Climate Center. Several time periods from 1-day up to 36-months."
	},
	"hprcc-acis": {
		"anchor": "HPRCC ACIS maps",
		"href": "https://hprcc.unl.edu/maps.php?map=ACISClimateMaps",
		"image": "samples/hprcc-acis_sample.png",
		"text": "The High Plains Regional Climate Center has an extensive collection of present and past maps of precipitation, temperature and Standardized Precipitation Index based on Applied Climate Information System (ACIS) data. These maps are updated daily."
	},
	"dmmaps": {
		"anchor": "Drought Monitor Weekly Maps",
		"href": "https://droughtcenter.unl.edu/USDMWeeklyMaps/US_Maps_current.pdf",
		"image": "samples/dmmaps_sample.png",
		"text": "A large, consolidated collection of weekly-updated maps produced for the US Drought Monitor. Many maps have the previous week's USDM depiction superimposed. Sources include: AHPS precipitation, SPI and SPEI; USGS streamflow; NLDAS soil moisture; HPRCC SPI; CPC SPI; VHI; GFS 7-day precipitation and temperature forecasts; KBDI; EDDI; VegDRI; ESI; GRACE-based groundwater and soil moisture; and AIRS-based temperature, RH and vapor pressure deficit."
	},
	"blends": {
		"anchor": "NDMC Blends",
		"href": "https://ndmcblends.unl.edu/Home.aspx",
		"image": "samples/blends_sample.png",
		"text": "Objective short-term and long-term weekly drought blends."
	},
	"nrcc-kbdi": {
		"anchor": "NRCC Gridded KBDI",
		"href": "https://nedews.nrcc.cornell.edu/NRCC_maps/kbdi_nedews_current.png",
		"image": "samples/nrcc-kbdi_sample.png",
		"text": "KBDI computed by NRCC using PRISM daily temperature and precipitation and NCEI gridded annual precipitation data."
	},
	"edd": {
		"anchor": "NWS GIS Viewer",
		"href": "https://viewer.weather.noaa.gov/general#layers=42904+40090+40091&x=-74.45136&y=44.96468&z=9.7&panel=layer",
		"image": "samples/edd_sample.jpg",
		"text": "The National Weather Service Enhanced Data Display is a platform that serves as a gateway to distribute high spatial and temporal resolution data that NWS forecasters generate. It allows users access to these raw data and provides the means to manipulate the data for their needs. EDD provides current and recently observed data, as well as, deterministic and probabilistic forecasts."
	},
	"nyc-resv": {
		"anchor": "New York City reservoir levels",
		"href": "https://www.nyc.gov/html/dep/html/drinking_water/maplevels_wide.shtml",
		"image": "samples/nyc-resv_sample.png",
		"text": "Map of New York City current reservoir levels provided by New York City Environmental Protection."
	},
	"qdri": {
		"anchor": "QuickDRI (Quick Drought Response Index)",
		"href": "https://quickdri.unl.edu/",
		"image": "samples/qdri_sample.jpg",
		"text": "The Quick Drought Response Index (QuickDRI) is a drought monitoring tool, which is tailored to detect short-term changes and rapid intensification of drought conditions through the integration of satellite, climate, and biophysical information. QuickDRI is updated on a weekly basis across the continental United States at a 1-km gridded spatial resolution. The primary goal of QuickDRI is to serve as an 'alarm' indicator of rapidly emerging events that are often difficult to detect using other drought indicators."
	},
	"vdri": {
		"anchor": "VegDRI (Vegetation Drought Response Index)",
		"href": "https://vegdri.unl.edu/",
		"image": "samples/vdri_sample.jpg",
		"text": "The Vegetation Drought Response Index (VegDRI) is a weekly national drought tool. VegDRI maps portray vegetation conditions as plants respond to solar energy, soil moisture, and other limiting factors. The VegDRI data and models that underpin the relatively-detailed VegDRI maps indicate levels of drought stress on vegetation across the conterminous U.S. at a 1 km spatial resolution."
	},
	"eddi": {
		"anchor": "EDDI (Evaporative Demand Drought Index)",
		"href": "https://www.esrl.noaa.gov/psd/eddi",
		"image": "samples/eddi_sample.png",
		"text": "The Evaporative Demand Drought Index is an experimental drought monitoring and early warning guidance tool. It examines how anomalous the atmospheric evaporative demand is for a given location and across a time period of interest. EDDI is available at 1-week through 12-month timescales. Currently, EDDI is generated daily, but there is a 5-day lag-time."
	},
	"sport": {
		"anchor": "NASA SPoRT",
		"href": "https://weather.msfc.nasa.gov/sport/case_studies/lis_NEUS.html",
		"image": "samples/sport_sample.png",
		"text": "SPoRT (Short-term Prediction Research and Transition) is a NASA project to transition unique observations and research capabilities to the operational weather community to improve short-term forecasts on a regional scale. Maps, including soil moisture, are regenerated each morning, shortly after midnight."
	},
	"grace": {
		"anchor": "NASA GRACE",
		"href": "https://nasagrace.unl.edu",
		"image": "samples/grace_sample.png",
		"text": "Groundwater and soil moisture maps based on terrestrial water storage observations derived from NASA's GRACE-FO (Gravity Recovery and Climate Experiment - Follow On) satellite data and integrated with other observations. The maps are updated weekly."
	},
	"nldas": {
		"anchor": "NLDAS Soil Moisture",
		"href": "https://www.cpc.ncep.noaa.gov/products/Drought/Monitoring/smp_new.shtml#",
		"image": "samples/nldas_sample.png",
		"text": "North-American Land Data Assimilation System (NLDAS) is a product of the National Oceanic and Atmospheric Administration (NOAA) National Centers for Environmental Prediction (NCEP) Environmental Modeling Center (EMC)s. The Climate Prediction Center (CPC) derives the NLDAS experimental drought monitor from near real-time soil moisture output from both the NASA MOSAIC and NCEP Noah land surface models. The anomalies and percentiles are based on a 28 year climatology (1980 - 2007). The maps are updated daily with about a 4-day lag."
	},
	"vic": {
		"anchor": "VIC Soil Moisture",
		"href": "https://hydro.ucla.edu/SurfaceWaterGroup/forecast/monitor/curr/conus.mexico/main_sm.shtml",
		"image": "samples/vic_sample.png",
		"text": "Soil moisture from UCLA VIC model. Maps have 1 to 2-day lag. National and links to regional maps available."
	},
	"usgs-sf": {
		"anchor": "USGS WaterWatch (streamflow)",
		"href": "https://waterwatch.usgs.gov/index.php?mt=real&st=ny%2Ch01&usst=ny&ushuc=&id=wwlmap_viewer",
		"image": "samples/usgs-sf_sample.jpg",
		"text": "The USGS WaterWatch site displays maps, graphs, and tables describing real-time, recent, and past streamflow conditions for the United States. The real-time information generally is updated on an hourly basis. Maps present streamflow conditions compared to historical streamflow and allow users to retrieve graphs of stream stage (water elevation) and flow. Hydrologic unit code (HUC) maps show average streamflow conditions for 1-, 7-, 14-, and 28-day periods, and for monthly average streamflow. Summary tables are provided along with time-series plots that depict variations in streamflow at a site through time."
	},
	"usgs-gw": {
		"anchor": "USGS Groundwater",
		"href": "https://water.usgs.gov/ogw/",
		"image": "samples/usgs-gw_sample.jpg",
		"text": "The USGS Groundwater Information Pages are an extensive collection of groundwater data, information and publications. The Groundwater Watch data pages group related wells and data from active well networks, and provide basic statistics about the water-level data collected by USGS water science centers. (At the time of this writing, the Groundwater Watch pages were not accessible via Google Chrome.)"
	},
	"cpc-blends": {
		"anchor": "CPC objective drought blends",
		"href": "https://www.cpc.ncep.noaa.gov/products/predictions/tools/edb/droughtblends.php",
		"image": "samples/cpc-blends_sample.jpg",
		"text": "Climate division-scale maps of long and short-term blends of drought indicators from the NWS Climate Prediction Center (CPC). Drought blends are produced each Monday and incorporate data through the previous Saturday. In addition to current maps, historical blend maps are available back to 2003."
	},
	"cpc-topsoil": {
		"anchor": "CPC statewide topsoil moisture",
		"href": "https://www.cpc.ncep.noaa.gov/products/monitoring_and_data/topsoil.shtml",
		"image": "samples/cpc-topsoil_sample.jpg",
		"text": "State maps of percent of state with topsoil moisture short or very short prepared by the NWS Climate Prediction Center (CPC) from USDA subjective reports. Current conditions and comparisons to 5 and 10-year means."
	},
	"cpc-pdsi": {
		"anchor": "CPC PDSI and CMI",
		"href": "https://www.cpc.ncep.noaa.gov/products/monitoring_and_data/drought.shtml",
		"image": "samples/cpc-pdsi_sample.jpg",
		"text": "The Palmer Drought Severity Index (PDSI) and Crop Moisture Index (CMI) are indices of the relative dryness or wetness affecting water sensitive economies. The data are provided by the NWS Climate Prediction Center (CPC) as maps and tables for the contiguous United States, presented by state and climate division."
	},
	"cpc-sm": {
		"anchor": "CPC Soil Moisture",
		"href": "https://www.cpc.ncep.noaa.gov/products/Soilmst_Monitoring/US/Soilmst/Soilmst.shtml#",
		"image": "samples/cpc-sm_sample.gif",
		"text": "Climate Prediction Center estimated soil moisture using a one-layer hydrological model. The model takes observed precipitation and temperature and calculates soil moisture, evaporation and runoff. The potential evaporation is estimated from observed temperature."
	},
	"cpc-hazards": {
		"anchor": "CPC Week 2 Hazards Outlook",
		"href": "https://www.cpc.ncep.noaa.gov/products/predictions/threats/threats.php",
		"image": "samples/cpc-hazards_sample.png",
		"text": "Climate Prediction Center outlook for potential weather hazards for the upcoming 8-14 day period. The product is updated every weekday and includes the experimental Rapid Onset Drought hazard type."
	},
	"spei": {
		"anchor": "SPEI Global Drought Monitor",
		"href": "https://spei.csic.es/map/maps.html#months=1",
		"image": "samples/spei_sample.jpg",
		"text": "The Standardized Precipitation-Evapotranspiration Index (SPEI) Global Drought Monitor offers near real-time information about drought conditions at the global scale, with a 0.5 degrees spatial resolution and a monthly time resolution. SPEI time-scales between 1 and 48 months are provided. The dataset is updated during the first days of the following month."
	},
	"nidis": {
		"anchor": "NIDIS Drought Portal",
		"href": "https://www.drought.gov/drought/",
		"image": "samples/nidis_sample.jpg",
		"text": "The National Integrated Drought Information System US Drought Portal (Drought.gov) provides a wide array of data, maps, tools and other drought resources for the country."
	},
	"dir": {
		"anchor": "NDMC Drought Impacts Reporter",
		"href": "https://go.unl.edu/DIRdash",
		"image": "samples/dir_sample.jpg",
		"text": "The National Drought Mitigation Center (NDMC) Drought Impact Reporter is a comprehensive database of drought impacts for the country from a variety of sources. Through the Drought Impact Reporter, you can submit reports of drought impacts in your area or view reports submitted by others. Report sources include media, users, CoCoRaHS, National Weather Service and other agencies. "
	},
	"ne-sweq": {
		"anchor": "New York/New England Snow Survey",
		"href": "https://www.nrcc.cornell.edu/regional/snowsurvey/snowsurvey.html",
		"image": "samples/ne_sweq_sample.png",
		"text": "Maps of snow water equivalent from snow surveys conducted throughout New York and New England, and compiled by NRCC. Updated bi-weekly on Friday beginning in early Janary and continuing to as late as early May."
	},
	"vtanr": {
		"anchor": "VT Drought Reporter",
		"href": "https://experience.arcgis.com/experience/be35cd1bf2c5407b9576f946f5b2f453",
		"image": "samples/vtanr_sample.jpg",
		"text": "Vermont Agency of Natural Resources crowd-sourced reports of drinking water shortages and drought impacts in Vermont. "
	},
	"enso": {
		"anchor": "NOAA ENSO Portal",
		"href": "https://www.climate.gov/enso",
		"image": "samples/enso_sample.png",
		"text": "El Niño and La Niña are the warm and cool phases of a recurring climate pattern across the tropical Pacific—the El Niño-Southern Oscillation, or “ENSO” for short. ENSO phase changes disrupt the large-scale air movements in the tropics, triggering a cascade of global side effects. NOAA’s El Niño and La Niña Portal provides – current status, explanatory links, progression and impacts at the United States and global scale."
	},
	"nrccdu": {
		"anchor": "NRCC Drought Page",
		"href": "https://www.nrcc.cornell.edu/regional/drought/drought.html",
		"image": "samples/nrccdu_sample.png",
		"text": "The Northeast Regional Climate Center's Drought Page features a weekly drought update (when drought exists anywhere in the Northeast) and links to other resources."
	},
	"cocorahs": {
		"anchor": "CoCoRaHS",
		"href": "https://www.cocorahs.org/",
		"image": "samples/cocorahs_sample.png",
		"text": "CoCoRaHS is an acronym for the Community Collaborative Rain, Hail and Snow Network.  CoCoRaHS is a unique, non-profit, community-based network of volunteers of all ages and backgrounds working together to measure and map precipitation (rain, hail and snow).   By using low-cost measurement tools, stressing training and education, and utilizing an interactive Web-site, our aim is to provide the highest quality data for natural resource, education and research applications. CoCoRaHS volunteers can also enter drought condition reports."
	},
	"nhdes-gw": {
		"anchor": "NHGS Groundwater Level Monitoring",
		"href": "https://nhdes.maps.arcgis.com/apps/dashboards/6b333fa640994c17a31993a9e5298043",
		"image": "samples/nhdes_sample.png",
		"text": "This WebMap displays the status of the most recent groundwater level measurements relative to the period of record monthly statistics calculated for the 30 groundwater wells monitored by NHGS, as well as the 3 USGS-monitored wells located in NH. Figures showing a 12-Month hydrographs with site statistics and a 24-month plots of groundwater measurements are available by selecting a site."
	},
	"negs_gw": {
		"anchor": "Groundwater Levels in New England",
		"href": "https://newengland.water.usgs.gov/web_app/GWW/GWW.html",
		"image": "samples/negs_sample.png",
		"text": "Map displaying wells that are part of the National Groundwater Monitoring Network which includes wells not measured by USGS, for example in New Hampshire and Vermont. You can also turn on and off continuous and periodically measurement wells (measured generally 1 time per month)."
	},
	"nygs_gw": {
		"anchor": "Groundwater Levels in New York",
		"href": "https://rconnect.usgs.gov/content/99cc8726-7baa-45af-a5bd-bced25ff82db/",
		"image": "samples/nygs_sample.png",
		"text": "Map displaying wells that are maintained by the U.S. Geological Survey New York Water Science Center with links to specific site data. Checkboxes allow you to turn on and off various aquifers."
	},
	"me-wells": {
		"anchor": "Maine Dry Well Survey",
		"href": "https://maine-dry-well-survey-maine.hub.arcgis.com",
		"image": "samples/mewells_sample.png",
		"text": "Results of responses to an on-going survey of reports of dry wells by the Maine Emergency Management Agency."
	},
	"cmor": {
		"anchor": "CMOR (Condition Monitoring Observer Reports",
		"href": "https://droughtimpacts.unl.edu/Tools/ConditionMonitoringObservations.aspx",
		"image": "samples/cmor_sample.png",
		"text": "The Condition Monitoring Observer Reports (CMOR) system is used to report drought-related conditions and impacts, and view a map of reports from around the country."
	},
	"ag-canada": {
		"anchor": "Agroclimate Maps (Canada)",
		"href": "https://agriculture.canada.ca/atlas/apps/aef/main/index_en.html?AGRIAPP=17",
		"image": "samples/agcanada_sample.png",
		"text": "Precipitation and other drought indices for Canada."
	},
	"nh-wells": {
		"anchor": "New Hampshire Dry Well Survey",
		"href": "https://survey123.arcgis.com/share/b7734a880fe6419db8b18a7d12a27d5d",
		"image": "samples/nhwells_sample.jpg",
		"text": "Site where New Hampshire residents can report dry wells."
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/linkInfo.json
// module id = 343
// module chunks = 0